import { useEffect, useState } from 'react'

const LOW_BATTERY_THRESHOLD_PCT = 20

const useBatteryStatus = () => {
    const [state, setState] = useState({
        supported: typeof navigator?.getBattery === 'function',
        level: null,
        levelPct: null,
        charging: null,
    })

    useEffect(() => {
        if (typeof navigator?.getBattery !== 'function') return
        let cancelled = false
        let battery = null
        let onLevel = null
        let onCharging = null

        const sync = b => {
            if (cancelled) return
            setState({
                supported: true,
                level: b.level,
                levelPct: Math.round((b.level ?? 0) * 100),
                charging: !!b.charging,
            })
        }

        navigator
            .getBattery()
            .then(b => {
                if (cancelled) return
                battery = b
                sync(b)
                onLevel = () => sync(b)
                onCharging = () => sync(b)
                b.addEventListener('levelchange', onLevel)
                b.addEventListener('chargingchange', onCharging)
            })
            .catch(() => {
                if (!cancelled) setState(s => ({ ...s, supported: false }))
            })

        return () => {
            cancelled = true
            if (battery) {
                if (onLevel) battery.removeEventListener('levelchange', onLevel)
                if (onCharging) battery.removeEventListener('chargingchange', onCharging)
            }
        }
    }, [])

    return state
}

export default useBatteryStatus
export { LOW_BATTERY_THRESHOLD_PCT }
